/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleBookingDisplay
 */
export interface VehicleBookingDisplay {
    /**
     * VehicleBooking id.
     * @type {number}
     * @memberof VehicleBookingDisplay
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    gondolaBookingId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    vendorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    vehicleClass?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    pickupLocation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleBookingDisplay
     */
    pickupDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    dropoffLocation?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VehicleBookingDisplay
     */
    dropoffDatetime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    confirmationNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VehicleBookingDisplay
     */
    totalRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDisplay
     */
    billingCurrency?: string | null;
}

/**
 * Check if a given object implements the VehicleBookingDisplay interface.
 */
export function instanceOfVehicleBookingDisplay(value: object): value is VehicleBookingDisplay {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function VehicleBookingDisplayFromJSON(json: any): VehicleBookingDisplay {
    return VehicleBookingDisplayFromJSONTyped(json, false);
}

export function VehicleBookingDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingDisplay {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
        'pickupLocation': json['pickup_location'] == null ? undefined : json['pickup_location'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : (new Date(json['pickup_datetime'])),
        'dropoffLocation': json['dropoff_location'] == null ? undefined : json['dropoff_location'],
        'dropoffDatetime': json['dropoff_datetime'] == null ? undefined : (new Date(json['dropoff_datetime'])),
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'totalRate': json['total_rate'] == null ? undefined : json['total_rate'],
        'billingCurrency': json['billing_currency'] == null ? undefined : json['billing_currency'],
    };
}

export function VehicleBookingDisplayToJSON(json: any): VehicleBookingDisplay {
    return VehicleBookingDisplayToJSONTyped(json, false);
}

export function VehicleBookingDisplayToJSONTyped(value?: VehicleBookingDisplay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'gondola_booking_id': value['gondolaBookingId'],
        'vendor_name': value['vendorName'],
        'vehicle_class': value['vehicleClass'],
        'pickup_location': value['pickupLocation'],
        'pickup_datetime': value['pickupDatetime'] == null ? value['pickupDatetime'] : value['pickupDatetime'].toISOString(),
        'dropoff_location': value['dropoffLocation'],
        'dropoff_datetime': value['dropoffDatetime'] == null ? value['dropoffDatetime'] : value['dropoffDatetime'].toISOString(),
        'confirmation_number': value['confirmationNumber'],
        'total_rate': value['totalRate'],
        'billing_currency': value['billingCurrency'],
    };
}

